import { useEmployeeDiscount } from '~/entrataReports';
import { useProperties } from '~/properties';
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridFooterContainer,
    GridFooter
} from '@mui/x-data-grid';
import Dimmer from '+/Dimmer';
import {
    Typography
} from '@material-ui/core';
import usePrint from '+/hooks/usePrint';

import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import * as React from 'react';
import { PrintDate } from '../../shared/components/PrintDate';


const EmployeeDiscounts = props => {

    const [property, setProperty] = React.useState(null);
    const { data: properties } = useProperties();
    const {
        data, isLoading, refetch, isFetching, isError
    } = useEmployeeDiscount(property?.id, { enabled: !!property });
    const { ref, Trigger } = usePrint({}, true);


    function CustomToolbar() {
        return (
            <GridToolbarContainer className='hide'>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarExport />
                <Trigger />
            </GridToolbarContainer>
        );
    }


    const columns = [
        {
            renderHeader: () => <strong>Property Name</strong>,
            field: 'property_name',
            flex: 1.5
        },
        {
            renderHeader: () => <strong>Unit Type</strong>,
            field: 'unit_type',
            flex: 0.8
        },
        {
            renderHeader: () => <strong>Bldg Unit</strong>,
            field: 'bldg_unit',
            flex: 0.8
        },
        {
            renderHeader: () => <strong>Status</strong>,
            field: 'status',
            flex: 0.8
        },
        {
            renderHeader: () => <strong>Primary Resident</strong>,
            field: 'primary_resident',
            flex: 0.8
        },
        {
            renderHeader: () => <strong>Lease Start Date</strong>,
            field: 'lease_start_date',
            flex: 0.8
        },
        {
            renderHeader: () => <strong>Lease End Date</strong>,
            field: 'lease_end_date',
            flex: 0.8
        },
        {
            renderHeader: () => <strong>Move In Date</strong>,
            field: 'move_in_date',
            flex: 0.8
        },
        {
            renderHeader: () => <strong>Lease Market Rent</strong>,
            field: 'lease_market_rent',
            flex: 0.7
        },
        {
            renderHeader: () => <strong>Lease Disc</strong>,
            field: 'amount',
            flex: 0.8
        },
        {
            renderHeader: () => <strong>Market Rent</strong>,
            field: 'marketRent',
            flex: 0.8
        },
        {
            renderHeader: () => <strong>Abs Disc</strong>,
            field: 'diff',
            flex: 0.7
        },
        {
            renderHeader: () => <strong>Charge Code</strong>,
            field: 'charge_code',
            flex: 0.8
        }
    ];

    React.useEffect(() => {

        if (property) {

            refetch(property.id);
        }

    }, [property, refetch]);

    if (isLoading || isFetching) {
        return <Dimmer />;
    }

    if (isError) {
        return 'Internal Error - Contact Technical Support';
    }

    return (
        <div ref={ref} className='print landscape reduce'>
            <div>
                <Typography gutterBottom variant='h4'>
                    Employee Discounts
                </Typography>
                <div>
                    <PrintDate isForPDF={false} />
                </div>
                <br/>
                <Box sx={{ minWidth: 120 }}>
                    <FormControl fullWidth>
                        <InputLabel id='demo-simple-select-label'>Property Names</InputLabel>
                        <Select
                            labelId='demo-simple-select-label'
                            id='demo-simple-select'
                            value={property}
                            label='Property Name'
                            onChange={e => setProperty(e.target.value)}
                        >
                            <MenuItem value={{ id: 'all' }}>All</MenuItem>
                            {
                                (properties || []).map((property, i) => (
                                    <MenuItem value={property}>{property.name}</MenuItem>
                                ))
                            }

                        </Select>
                    </FormControl>
                </Box>
                <br/>
                {property && data && (
                    <DataGrid id='datagrid'
                        columns={columns}
                        rows={data}
                        autoHeight
                        loading={isLoading}
                        components={{
                            Toolbar: CustomToolbar,
                            Footer: () => (
                                <GridFooterContainer>
                                    <GridFooter />
                                </GridFooterContainer>

                            )
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default EmployeeDiscounts;

